///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class HigscoreScreen extends BaseScreen {

        bg:Phaser.GameObjects.Container;
        btnCancel:Phaser.GameObjects.Container;
        btnRetry:Phaser.GameObjects.Container;
        txt:Phaser.GameObjects.Text;
        hs_top_bg:Phaser.GameObjects.Container;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.bg = new Phaser.GameObjects.Container(this.scene, 0, -200, [
                new Phaser.GameObjects.Image(this.scene, 0, 50, 'bg-atlas', 'bg1_bg0000').setOrigin(0, 0),
                new Phaser.GameObjects.Image(this.scene, 728, 50, 'bg-atlas', 'bg1_bg0000').setOrigin(0, 0),
            ]);
            this.add(this.bg);
            this.bg.x = 0;
            this.scene.tweens.add({
                targets: this.bg,
                x: -728,
                duration: 40000,
                ease: Phaser.Math.Easing.Linear,
                repeat: -1
            });

            this.hs_top_bg = new Phaser.GameObjects.Container(this.scene, 240, 60, [
                new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'hs_top_bg0000')
            ]);
            this.add(this.hs_top_bg);
            let hs_label = this.scene.add.text(0, -3, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 35,
                "color": "#FFFFFF",
                "align": 'left'
            });
            hs_label.setOrigin(0.5, 0.5);
            this.hs_top_bg.add(hs_label);
            nscs.gameplay.Gameplay.setText(hs_label, 'HighScoresTitle');

            this.btnCancel = new Phaser.GameObjects.Container(this.scene, 0, 0);
            this.add(this.btnCancel);
            this.btnCancel.add(this.btnCancel['-img-'] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'btn_back'+'0000'));
            let cancel_label:Phaser.GameObjects.Text = this.scene.add.text(0, -5, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 19,
                "color": "#FFFFFF",
                "align": 'left'
            });
            cancel_label.setOrigin(0.5, 0.5);
            this.btnCancel.add(cancel_label);
            nscs.gameplay.Gameplay.setText(cancel_label, 'CancelBtn');

            this.btnRetry = new Phaser.GameObjects.Container(this.scene, 0, 0);
            this.add(this.btnRetry);
            this.btnRetry.add(this.btnRetry['-img-'] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'btn_back'+'0000'));
            let retry_label:Phaser.GameObjects.Text = this.scene.add.text(0, -5, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 19,
                "color": "#FFFFFF",
                "align": 'left'
            });
            retry_label.setOrigin(0.5, 0.5);
            this.btnRetry.add(retry_label);
            nscs.gameplay.Gameplay.setText(retry_label, 'RetryBtn');

            this.txt = this.scene.add.text(game.scale.width/2, 0, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 13,
                "color": "#00436F",
                "align": 'center'
            });
            this.txt.setOrigin(0.5, 0.5);
            this.add(this.txt);
            this.txt.setLineSpacing(5);
            this.txt.setWordWrapWidth(275);

            this.btnCancel['-img-'].setInteractive({cursor: 'pointer'});
            this.btnCancel['-img-'].once('pointerup', ()=>{
                nscs.scene.MainScene.instance.switchScreen(new nscs.screen.MainMenuScreen(this.scene));
                nscs.sound.SoundManager.getInstance().playSound('winnerSND');
            });
            this.btnRetry['-img-'].setInteractive({cursor: 'pointer'});
            this.btnRetry['-img-'].on('pointerup', ()=>{
                this.switchState(true);
                nscs.sound.SoundManager.getInstance().playSound('winnerSND');
            });

            this.switchState(true);
        }

        public switchState(loading:boolean):void {
            if (loading) {
                this.btnCancel.x = game.scale.width / 2;
                this.btnCancel.y = 210;
                this.btnRetry.visible = false;
                this.txt.y = 160;
                nscs.gameplay.Gameplay.setText(this.txt, 'HighScoresConnecting');
                this.hs_top_bg.visible = false;

                nscs.util.Functions.delayedCall(5000, ()=>{
                    if (!this.parentContainer) return;
                    this.switchState(false);
                });
            } else {
                this.btnCancel.x = game.scale.width / 2 - 90;
                this.btnCancel.y = 250;
                this.btnRetry.x = game.scale.width / 2 + 90;
                this.btnRetry.y = 250;
                this.btnRetry.visible = true;
                this.txt.y = 150;
                nscs.gameplay.Gameplay.setText(this.txt, 'HighScoresUnreachable');
                this.hs_top_bg.visible = true;
            }
        }
    }
}